module.exports = __webpack_public_path__ + "static/media/sqsSa_sm1.313bdd99.png";